<template>
  <div class="mobile-scroll-wrapper">
    <div class="task-create" :class="{ 'wxwork-mobile': isWxWorkMobile }">
      <h2>两横一竖工作任务</h2>
      <form @submit.prevent="submitForm">
        <!-- 任务标题/描述 -->
        <div class="form-group">
          <label>任务标题</label>
          <el-input v-model="form.title" type="text" required placeholder="请输入任务标题" class="unified-width"></el-input>
        </div>
        <div class="form-group">
          <label>任务描述</label>
          <el-input
            v-model="form.description"
            type="textarea"
            placeholder="请输入任务描述"
            :rows="3"
            class="unified-width"
          ></el-input>
        </div>

        <!-- 任务分数 -->
        <div class="form-group">
          <label>任务分数</label>
          <el-input
            v-model="form.score"
            type="number"
            required
            placeholder="请输入任务分值（如：10）"
            min="1"
            max="100"
            class="unified-width"
          ></el-input>
        </div>

        <!-- 创建人 -->
        <div class="form-group">
          <label>创建人ID</label>
          <el-input
            v-model="form.creatorUserId"
            required
            placeholder="如：user001"
            disabled
            readonly
            style="background-color: #f5f5f5; color: #666;"
            class="unified-width"
          ></el-input>
        </div>

        <!-- 任务完成人 -->
        <div class="form-group">
          <label>任务完成人</label>
          <el-select
            v-model="form.assigneeUserId"
            required
            filterable
            placeholder="请选择或搜索完成人（用户名/ID）"
            clearable
            class="unified-width"
          >
            <el-option
              v-for="user in wxUsers"
              :key="user.userId"
              :label="`${user.name} (${user.userId})`"
              :value="user.userId"
            ></el-option>
          </el-select>
        </div>

        <!-- 多级审核人配置 -->
        <div class="form-group">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <label>审核节点配置</label>
            <el-select v-model.number="auditLevelCount" placeholder="选择审核节点数" style="width: 120px;">
              <el-option label="1个节点" :value="1"></el-option>
              <el-option label="2个节点" :value="2"></el-option>
              <el-option label="3个节点" :value="3"></el-option>
              <el-option label="4个节点" :value="4"></el-option>
              <el-option label="5个节点" :value="5"></el-option>
            </el-select>
          </div>
          
          <!-- 修复核心：循环生成1~N级审核人（数字类型循环） -->
          <div v-for="level in Array.from({length: auditLevelCount}, (_, i) => i + 1)" :key="level" style="margin-top: 10px;">
            <label style="font-weight: normal;">{{ level }}级审核人 <span style="color: red;">*</span></label>
            <el-select
              v-model="form.approvers[level]"
              required
              filterable
              placeholder="请选择或搜索审核人（用户名/ID）"
              clearable
              class="unified-width"
            >
              <el-option
                v-for="user in wxUsers"
                :key="user.userId"
                :label="`${user.name} (${user.userId})`"
                :value="user.userId"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="form-group">
          <label>提醒配置</label>
          <el-select
            v-model="form.remindType"
            placeholder="请选择提醒类型"
            required 
            class="unified-width"
          >
            <el-option label="到期截止前提醒" value="BEFORE_DUE"></el-option>
            <el-option label="每日固定提醒" value="DAILY"></el-option>
          </el-select>
        </div>
       <!-- 开始时间 -->
        <div class="form-group">
          <label>开始时间</label>
          <el-date-picker
            v-model="form.createdAt"
            type="datetime"
            required
            placeholder="选择开始日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="unified-width"
          ></el-date-picker>
        </div>


        <!-- 截止时间 -->
        <div class="form-group">
          <label>截止时间</label>
          <el-date-picker
            v-model="form.dueDate"
            type="datetime"
            required
            placeholder="选择截止日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="unified-width"
          ></el-date-picker>
        </div>

        <!-- 操作按钮 -->
        <div class="btn-group">
          <el-button type="primary" @click="submitForm" class="submit-btn">创建任务</el-button>
          <el-button type="default" @click="$router.push('/')" class="back-btn">返回任务列表</el-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { createTask, getDepartmentUsers } from '@/api/task';
import { isWxWorkEnv } from '@/utils/request';

export default {
  name: 'TaskCreate',
  data() {
    return {
      form: {
        title: '',
        description: '',
        score: '', // 任务分数
        creatorUserId: '',
        assigneeUserId: '',
        approvers: { // 仅存储各层级审核人ID
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        },
        dueDate: '',
        createdAt:'',
        remindType: 'BEFORE_DUE' 
      },
      wxUsers: [],
      loadingUsers: false,
      isWxWorkMobile: false,
      auditLevelCount: 1 // 改为数字类型，默认1个审核节点
    };
  },
  created() {
    this.isWxWorkMobile = isWxWorkEnv() && /mobile/i.test(navigator.userAgent);
  },
  mounted() {
    const currentAdmin = localStorage.getItem('adminName');
    if (currentAdmin) {
      this.form.creatorUserId = currentAdmin;
    } else {
      this.$message.warning('未检测到登录信息，请重新登录');
      this.$router.push('/login');
    }
    this.fetchWxUsers();
  },
  methods: {
    async fetchWxUsers() {
      this.loadingUsers = true;
      try {
        const res = await getDepartmentUsers(1, true);
        this.wxUsers = res.data || [];
        this.$message.success(`成功加载 ${this.wxUsers.length} 个企业微信用户`);
      } catch (error) {
        console.error('获取企业微信用户失败：', error);
        this.$message.error('企业微信用户获取失败，请检查后端服务');
      } finally {
        this.loadingUsers = false;
      }
    },
    async submitForm() {
      // 基础必填项校验
      if (!this.form.title) {
        this.$message.warning('请输入任务标题！');
        return;
      }
      if (!this.form.score) {
        this.$message.warning('请输入任务分数！');
        return;
      }
      if (!this.form.assigneeUserId) {
        this.$message.warning('请选择任务完成人！');
        return;
      }
      if (!this.form.dueDate) {
        this.$message.warning('请选择截止时间！');
        return;
      }
     if (!this.form.createdAt) {
        this.$message.warning('请选择开始时间！');
        return;
      }
      // 审核人校验：选N个节点就必须填1~N级所有审核人
      let hasEmptyAuditor = false;
      for (let i = 1; i <= this.auditLevelCount; i++) {
        if (!this.form.approvers[i]) {
          hasEmptyAuditor = true;
          this.$message.warning(`请选择${i}级审核人！`);
          break;
        }
      }
      if (hasEmptyAuditor) return;

      try {
        // 构造提交数据：仅保留选中节点的审核人
        const submitData = {
          ...this.form,
          auditLevelCount: this.auditLevelCount, // 传递审核节点总数
          approvers: {}
        };
        for (let i = 1; i <= this.auditLevelCount; i++) {
          submitData.approvers[i] = this.form.approvers[i];
        }

        await createTask(submitData);
        this.$message.success('任务创建成功！');
        
        // 重置表单
        this.resetForm();
        this.$router.push('/');
      } catch (error) {
        console.error('创建任务失败：', error);
        this.$message.error('创建任务失败，请检查参数是否正确');
      }
    },
    // 重置表单
    resetForm() {
      this.form = {
        title: '',
        description: '',
        score: '',
        creatorUserId: this.form.creatorUserId, // 保留创建人ID
        assigneeUserId: '',
        approvers: { 1: '', 2: '', 3: '', 4: '', 5: '' },
        dueDate: '',
        createdAt:'',
        remindType: 'BEFORE_DUE' 
      };
      this.auditLevelCount = 1; // 重置为默认1个审核节点
    }
  }
};
</script>

<style scoped>
.task-create {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
}
.wxwork-mobile {
  max-width: 100% !important;
  margin: 0 !important;
  padding: 10px !important;
  border: none !important;
}
.wxwork-mobile h2 {
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
}
.wxwork-mobile .form-group {
  margin-bottom: 15px !important;
}
.wxwork-mobile label {
  font-size: 15px !important;
  margin-bottom: 5px !important;
}
.wxwork-mobile .unified-width {
  font-size: 14px !important;
  padding: 10px !important;
}
.wxwork-mobile .btn-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}
.wxwork-mobile .submit-btn,
.wxwork-mobile .back-btn {
  width: 100% !important;
  padding: 12px 0 !important;
}

.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #606266;
}
.unified-width {
  width: 100% !important;
  box-sizing: border-box;
}
.el-button {
  margin-right: 10px;
}
.btn-group {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .task-create {
    max-width: 100%;
    margin: 10px;
    padding: 10px;
  }
  .form-group {
    margin-bottom: 15px;
  }
  label {
    font-size: 14px;
  }
}
.mobile-scroll-wrapper {
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20px;
}
</style>